module.exports = __webpack_public_path__ + "static/media/img8.15d9c445.jpeg";